import { Component,OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import {Validators, FormBuilder, FormGroup,FormControl } from '@angular/forms';
import {OtpPage} from'../otp/otp';
import {MyvariableService} from '../home/constantvariable';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import {HomePage} from '../home/home';
import {KiloMenuPage} from "../kilomenu/kilomenu";
import {KiloPartyPage} from "../kiloparty/kiloparty";
import {KiloStorePage} from "../kilostore/kilostore";



@Component({
	selector: 'page-profile',
	templateUrl: 'profile.html',
	providers:[MydataService,MyUrlService,JsonData,MyvariableService]
})
export class ProfilePage implements OnInit {
	LOGINFORGOT= this.MyvariableService.LOGINFORGOT;
	selectItem:string;
	editdataDt:Array<JsonData>;
	jsonDt : Array<JsonData>;
	private todo : FormGroup;
	citysss:string;
	description:any;
	descriptiones:any;
	descriptions:any;
	constructor(private formBuilder: FormBuilder,private http:Http,public navCtrl: NavController,public loading: LoadingController,private mydataService: MydataService,private myurlService: MyUrlService,public alerCtrl: AlertController,private MyvariableService: MyvariableService) {
		
	    var xyz = window.localStorage.getItem('userid');
		var name= window.localStorage.getItem('names');
		//var name = window.localStorage.getItem('getProfileName');
		//alert("get Profile Info === >"+		window.localStorage.getItem('getProfileName'))

		var mobileno= window.localStorage.getItem('mobilenos');
		var emailid= window.localStorage.getItem('emailids');
		var city= window.localStorage.getItem('citys');
		//var pan= window.localStorage.getItem('pan');
		var gstin= window.localStorage.getItem('gstin');
		
		
		this.todo = this.formBuilder.group({
			
			userid: [xyz,Validators],
			name: [name, Validators],
			mobileno:[mobileno, Validators],
			emailid:[emailid, Validators],
			city: [city, Validators],
			gstin:[gstin,Validators],
			"langs": new FormControl({value: 'rust', disabled: false})
		});
		
	}
	
	ngOnInit(){
		
		this.description=window.localStorage.getItem('description_kilomenus');
		//alert(this.description);
		this.descriptiones=window.localStorage.getItem('description_kilopartys');
		//alert(this.descriptiones);
		this.descriptions=window.localStorage.getItem('description_kilostores');
		//alert(this.descriptions);
		
		
		var userid=window.localStorage.getItem('userid');
		var kiloSabjiJSONdata = JSON.stringify({'userid':userid});
		//console.log("Product Url--->"+this.myurlService.PROFILEURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
		let loader = this.loading.create({content: '',});
		
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.PROFILEURL,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error =>this.errorFunction(loader,error),() =>this.profileService(loader));
			
		});
		
	}
	
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
	}
	logForm(helllo,name,mobileno,emailid,city,gstin){
		 //alert(relationship);
		
		 window.localStorage.setItem('getProfileName',name);
		 window.localStorage.setItem('getProfileNumber',mobileno);
		window.localStorage.setItem('getProfileEmailid',emailid);
		window.localStorage.setItem('getProfileAddress',city);
		window.localStorage.setItem('getProfileGstin',gstin);
		//window.localStorage.setItem('getProfilepan',pan);
		
		 
		
		if(name.match(/[!$%^&*()+|~=`{}\[\]:";#@'<>?,.\/\\0-9]/g) || name=='')
		{
			this.showAlertname();
		}else if(mobileno.match(/[!$%^&*()+|~=`{}\[\]:";#@'<>?,.\/\\a-zA-Z\s ]/g) || mobileno=='')
		{
			this.showAlertmobileno();
		}else if(city.match(/[!$%^&*()+|~=`{}\[\]:";#@'<>?,.\/\\0-9]/g) || city=='')
		{
			this.showAlertcity();
		}else if(emailid==''||emailid==null)
		{
			this.serviceCall()
		}else if(emailid.match('[a-z0-9]+@[a-z0-9]+.[a-z]+')){
				if(emailid.match('[.]')){
					this.serviceCall();
					}else{
					this.showAlertemailid();
				}
				}else{
				this.showAlertemailid();
			}
		
	}
	
	serviceCall=function(){
	
		
		var names = window.localStorage.getItem('getProfileName');
		////console.log(this.todo.value+"     "+helllo);
		//alert("update Button view==>"+window.localStorage.getItem('getProfileName')+window.localStorage.getItem('getProfileNumber')+window.localStorage.getItem('getProfileEmailid')+window.localStorage.getItem('getProfileAddress'));
	var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"name":window.localStorage.getItem('getProfileName'),"mobileno":window.localStorage.getItem('getProfileNumber'),"emailid":window.localStorage.getItem('getProfileEmailid'),"city":window.localStorage.getItem('getProfileAddress'),"gstNo":window.localStorage.getItem('getProfileGstin'),"gender":window.localStorage.getItem('gender')/*"panNo":window.localStorage.getItem('getProfilepan')*/});
		
		//console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.PROFILEUPDATE+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
		let loader = this.loading.create({content: '',});
		
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.PROFILEUPDATE ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.profileEditService(loader));
		});
	}
	
	profileService=function(loader){
		this.userdataDt = this.jsonDt.userdata;
		this.userId = this.jsonDt.userdata[0].id;
		this.userName = this.jsonDt.userdata[0].name;
		this.userMobile = this.jsonDt.userdata[0].mobileNo;
		this.userEmailid = this.jsonDt.userdata[0].emailid;
		this.userAddress = this.jsonDt.userdata[0].address;
			//this.userpan = this.jsonDt.userdata[0].panNo;
				this.usergstin = this.jsonDt.userdata[0].gstNo;
		window.localStorage.setItem('getProfileName',this.userName);
		window.localStorage.setItem('getProfileNumber',this.userMobile);
		window.localStorage.setItem('getProfileEmailid',this.userEmailid);
		window.localStorage.setItem('getProfileAddress',this.userAddress);
		window.localStorage.setItem('getProfileGstin',this.usergstin);
		//window.localStorage.setItem('getProfilepan',this.userpan);
		
		//alert("set value in text view==>"+window.localStorage.getItem('getProfileName')+window.localStorage.getItem('getProfileNumber')+window.localStorage.getItem('getProfileEmailid')+window.localStorage.getItem('getProfileAddress'));
		//alert(this.userAddress);
		//this.jsonDt.userdata.id
	
		//console.log("userdata receive jsondata ==>"+JSON.stringify(this.jsonDt.userdata));
		//console.log("userdata receive jsondata ==>"+JSON.stringify(this.jsonDt.userdata[0].id));
		loader.dismiss();
	}
	
	
	profileEditService=function(loader){
		this.editdataDt = this.jsonDt.datas;
		//console.log("editdata receive jsondata ==>"+JSON.stringify(this.jsonDt.datas));
		loader.dismiss();
		this.showAlertsucces();
	}
	
	
	
	forgotpass(mobile)
	{
		if(mobile!=''){
			
			//console.log(mobile);
			if(this.mydataService.checkInternetFunction()=="0"){
				////console.log("Internet UnAvailable")
				}else  if(this.mydataService.checkInternetFunction()=="1"){
				var kiloSabjiJSONdata = JSON.stringify({"mobileno":mobile});
				//console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.FORGOTPASS+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
				
				let loader = this.loading.create({content: '',});
				
				loader.present().then(() => {
					this.mydataService.postJSON(this.myurlService.FORGOTPASS ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.forgetPassService(loader));
					
				});
			}
			}else{
			this.showAlertotp();
			
		}
		
	}
	forgetPassService=function(loader){
		//console.log("jsondata ==>"+JSON.stringify(this.jsonDt));
		
		let uid = this.jsonDt.sinupdata;
		let msg = this.jsonDt.msg;
		this.LOGINFORGOTWRONG= this.MyvariableService.LOGINFORGOTWRONG;
		// alert(uid);
		loader.dismiss();
		if(uid!=''){
			window.localStorage.setItem('sinupid',  uid);
			window.localStorage.setItem('phoneno',  msg);
			
			var xyz = window.localStorage.getItem('sinupid');
			// alert(JSON.stringify(xyz));
			window.localStorage.setItem('otpTypee','changepass');
			this.navCtrl.push(OtpPage);
			
			}else{
			this.showAlerwrongmobile();
		}
	}
	
	selectionGender(selecItem){
			 //alert("work--->"+selecItem);
			this.selectItem = selecItem;
			window.localStorage.setItem('gender',this.selectItem);
			//var Gender=window.localStorage.getItem('gender');
			//alert('ccccccccccccccc'+Gender);
			
			
	}
			
	showAlertotp=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.LOGINFORGOT,
			buttons: ['OK']
		});
		alert.present();
	}
	showAlerwrongmobile=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.LOGINFORGOTWRONG,
			buttons: ['OK']
		});
		alert.present();
	}
	
	showAlertmobileno=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please enter valid mobile no',
			buttons: ['OK']
		});
		alert.present();
	}
	showAlertname=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please enter correct name',
			buttons: ['OK']
		});
		alert.present();
	}
	showAlertcity=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please enter correct city name',
			buttons: ['OK']
		});
		alert.present();
	}
	showAlertemailid=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please enter valid email id',
			buttons: ['OK']
		});
		alert.present();
	}
	
	/*showAlertsucces=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Profile successfully updated ',
			buttons: ['OK']
		});
		alert.present();
	}*/
	showAlertsucces=function() {
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: "Profile successfully updated",
			buttons: [ {
				text: 'Ok',
				handler: data => {
					this.navCtrl.push(HomePage);			
				}
			}
			]
		});
		alert.present();
	}
	aaa(checkPara,getProfilePara)
	{
		if(checkPara=="profileName"){
		window.localStorage.setItem('getProfileName',getProfilePara);
		}else if(checkPara=="profileNumber")
		{
		window.localStorage.setItem('getProfileNumber',getProfilePara);
		}else if(checkPara=="profileEmail")
		{
		window.localStorage.setItem('getProfileEmailid',getProfilePara);
		}else if(checkPara=="profileAddress")
		{
		window.localStorage.setItem('getProfileAddress',getProfilePara);
		}
		else if(checkPara=="profileGstin")
		{
		window.localStorage.setItem('getProfileGstin',getProfilePara);
		}
		/*else if(checkPara=="profilePan")
		{
		window.localStorage.setItem('getProfilepan',getProfilePara);
		}*/


//alert("Click text view==>"+window.localStorage.getItem('getProfileName')+window.localStorage.getItem('getProfileNumber')+window.localStorage.getItem('getProfileEmailid')+window.localStorage.getItem('getProfileAddress'));

		
		
				
	}
	kilomenu(cartid)
	{
		window.localStorage.setItem('localid', cartid );
		//window.localStorage.setItem('subcatid', subcat );
		//var xyz = window.localStorage.getItem('localid');
		
		//alert(cartid)
		if(cartid==1)
		{
			//this.navCtrl.push(KiloMenuPage);
			this.navCtrl.setRoot(KiloMenuPage);
		}
		if(cartid==2)
		{
			//this.navCtrl.push(KiloPartyPage);
			this.navCtrl.setRoot(KiloPartyPage);
		}
		if(cartid==3)
		{
			//this.navCtrl.push(KiloStorePage);
			this.navCtrl.setRoot(KiloStorePage);
		}
		
	}
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts